import { Module } from 'vuex';
import { PermissionService } from './permission.service';
const service = new PermissionService();

export interface PermissionState {}

const PermissionStore: Module<PermissionState, any> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getPermissionModelScopes(context, { resource_type, requires_id = 0 }) {
         const response = await service.getPermissionModelScopes(resource_type, requires_id);
         return response;
      },
      async postBulk(context, { resource_type, resource_id, actions }: { resource_type: string; resource_id: number; actions: string[] }) {
         const BODY = {
            resource_type,
            resource_id,
            actions,
         };

         const response = await service.postBulk(BODY);
         return response;
      },
   },
};

export default PermissionStore;
